import { MetricsDictionary } from '@tw/types/module/metrics/metrics';
import { servicesInBlended } from './constants';
import { sum } from './utils';

export const blendedMetrics: MetricsDictionary = {
  blendedConversionValue: {
    key: 'blendedConversionValue',
    label: 'Blended Conversion Value',
    shortLabel: 'Blended CV',
    type: 'ads',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: [],
    showInCreativeTable: [],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    hideInActivities: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
  },
  blendedSpend: {
    key: 'blendedSpend',
    label: 'Blended Spend',
    shortLabel: 'Blended Spend',
    type: 'ads',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: [],
    showInCreativeTable: [],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    chart: 'chartBlendedAds',
  },
  blendedRoas: {
    key: 'blendedRoas',
    label: 'Blended ROAS',
    shortLabel: 'Blended ROAS',
    type: 'ads',
    toFixed: 2,
    format: 'decimal',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    showInRules: ['account'],
    allowOrderBy: true,
    chart: 'chartRoas',
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedRoas');
    },
  },
  blendedCpm: {
    key: 'blendedCpm',
    label: 'Blended CPM',
    shortLabel: 'Blended CPM',
    showInCreativeCard: [],
    showInCreativeTable: ['all'],
    showInServices: ['triple-whale'],
    format: 'currency',
    toFixed: 2,
    type: 'ads',
    showInCreativeByDefault: true,
    showInPixelByDefault: false,
    showInRules: ['account', 'campaign', 'adset', 'ad'],
    allowOrderBy: true,
    valueIsNegative: true,
    chart: 'cpmChart',
    calculateSum: (items) => {
      return sum(items, 'blendedCpm');
    },
  },
  blendedCPC: {
    key: 'blendedCPC',
    label: 'Blended CPC',
    shortLabel: 'Blended CPC',
    type: 'ads',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    showInRules: ['account'],
    allowOrderBy: true,
    chart: 'chartCPC',
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedCPC');
    },
  },
  blendedCTR: {
    key: 'blendedCTR',
    label: 'Blended CTR',
    shortLabel: 'Blended CTR',
    type: 'ads',
    toFixed: 2,
    format: 'percent',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    showInRules: ['account'],
    allowOrderBy: true,
    chart: 'chartCTR',
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedCTR');
    },
  },
  blendedNewCustomerRoas: {
    key: 'blendedNewCustomerRoas',
    label: 'Blended New Customer ROAS',
    shortLabel: 'Blended NC ROAS',
    type: 'ads',
    toFixed: 2,
    format: 'decimal',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedNewCustomerRoas');
    },
    chart: 'chartNewCustomerRoas',
  },
  blendedNcCpa: {
    key: 'blendedNcCpa',
    label: 'Blended New Customer CPA',
    shortLabel: 'Blended NC CPA',
    type: 'ads',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedNcCpa');
    },
    chart: 'chartNewCustomersCpa',
  },
  blendedCpa: {
    key: 'blendedCpa',
    label: 'Blended CPA',
    shortLabel: 'Blended CPA',
    type: 'ads',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedCpa');
    },
    chart: 'chartTotalCpa',
  },
  blendedPoas: {
    key: 'blendedPoas',
    label: 'Blended POAS',
    shortLabel: 'Blended POAS',
    type: 'ads',
    toFixed: 2,
    format: 'decimal',
    hideInPixel: true,
    showInCreativeCard: ['product'],
    showInCreativeTable: ['product'],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    calculateSum: (items) => {
      return sum(items, 'blendedPoas');
    },
    chart: 'poasChart',
  },
  netProfit: {
    key: 'netProfit',
    label: 'Net Profit',
    shortLabel: 'Net Profit',
    type: 'shop',
    toFixed: 2,
    format: 'currency',
    hideInPixel: true,
    showInCreativeCard: [],
    showInCreativeTable: [],
    showInCreativeByDefault: false,
    showInPixelByDefault: false,
    allowOrderBy: true,
    dependOnServices: servicesInBlended,
    showInServices: ['triple-whale'],
    chart: 'totalNetProfitChart',
  },
};
